import { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  Dialog,
  DialogContent,
} from "@mui/material";
import axios from "axios";
import { Close } from "@mui/icons-material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import GetAppOutlinedIcon from "@mui/icons-material/GetAppOutlined";
import { toast } from "react-toastify";
import moment from "moment";
const DosserTermSheet = () => {
  const [dossierTermSheet, setDossierTermSheet] = useState([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [open, setOpen] = useState(false);
  const [opendel, setOpenDel] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);
  const [id, setId] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState(false);
  const [file, setFile] = useState("");
  useEffect(() => {
    getAllDossierTermsheet(0, "");
  }, []);

  const getAllDossierTermsheet = (page, search) => {
    const data = {
      page: page,
      limit: 10,
      searchChar: search,
    };
    axios
      .post(process.env.REACT_APP_BACKEND + "get-dossertermsheet", data, {
        headers: { Authorization: `Bearer ${localStorage?.getItem("token")}` },
      })
      .then((resp) => {
        setDossierTermSheet(resp && resp.data && resp.data.data);
        setCount(resp && resp.data && resp.data.totalcount);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const columns = [
    {
      name: "marketsOfInterest",
      label: "Markets of interest",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "supplyRequired",
      label: "Supply Required",
      options: {
        filter: true,
        sort: false,
      },
    },

    {
      name: "indicativeVolumes",
      label: "Indicative Volumes",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>{dossierTermSheet[dataIndex]?.status ? "Agreed" : "Disagreed"}</>
          );
        },
      },
    },
    {
      name: "Dossier",
      label: "Dossier",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <>{dossierTermSheet[dataIndex]?.dossierId?.ListingTitle}</>;
        },
      },
    },
    {
      name: "userId",
      label: "User",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <>{dossierTermSheet[dataIndex]?.userId?.name}</>;
        },
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <>{dossierTermSheet[dataIndex]?.userId?.Email}</>;
        },
      },
    },
    {
      name: "createdAt",
      label: "Submitted Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(dossierTermSheet[dataIndex]?.createdAt).format(
                "DD-MM-YYYY"
              )}
            </div>
          );
        },
      },
    },

    {
      name: "indicativeVolumes",
      label: "CDA/ NDA",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          const fileUrl = dossierTermSheet[dataIndex]?.cdaOrNda;
          return (
            <Tooltip title={fileUrl ? "Download CDA/NDA" : "No file available"}>
              <span>
                {" "}
                {/* span wrapper to allow tooltip on disabled button */}
                <IconButton
                  aria-label="download Dosser TermSheet"
                  onClick={() => handleDownload(fileUrl)}
                  disabled={!fileUrl}
                >
                  <GetAppOutlinedIcon className="fs-20" />
                </IconButton>
              </span>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "indicativeVolumes",
      label: "RFQ",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          const fileUrl = dossierTermSheet[dataIndex]?.rfq;

          return (
            <Tooltip title={fileUrl ? "Download RFQ" : "No file available"}>
              <span>
                <IconButton
                  aria-label="download RFQ"
                  onClick={() => handleDownload(fileUrl)}
                  disabled={!fileUrl}
                >
                  <GetAppOutlinedIcon className="fs-20" />
                </IconButton>
              </span>
            </Tooltip>
          );
        },
      },
    },

    {
      name: "Action",
      label: "Action",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="Delete Dosser TermSheet">
                <IconButton
                  aria-label="delete Dosser TermSheet"
                  onClick={() =>
                    handleOpen(dossierTermSheet[dataIndex]?._id, "delete")
                  }
                >
                  <DeleteOutlineOutlinedIcon className="fs-20 delete-icon" />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];
  const handleDownload = async (fileUrl) => {
    if (!fileUrl) return;

    try {
      const response = await fetch(fileUrl, {
        method: "GET",
        headers: {
          // Add any headers here if needed
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      console.log("fileUrl", fileUrl);
      const blob = await response.blob();
      //const fileName = fileUrl.split("/").pop();// Previously this was generating random NUmbers with Filename
      const rawFileName = fileUrl.split("/").pop();
      const fileName = rawFileName?.includes("-")
        ? rawFileName.substring(rawFileName.indexOf("-") + 1)
        : rawFileName;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || "download.pdf"; // fallback filename
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url); // clean up
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  //option for mui datatable
  const options = {
    responsive: "standard",
    download: false,
    selectableRows: false,
    filter: false,
    viewColumns: false,
    serverSide: true,
    count: count,
    rowsPerPageOptions: [], // hide the "Rows per page" dropdown by providing an empty array
    rowsPerPage: 10,
    page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        console.log(tableState.page, "Count");
        getAllDossierTermsheet(tableState.page, "");
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      getAllDossierTermsheet(page, searchText);
    },
  };
  //Function to make dailog box open and set the state

  const handleOpen = (dossierTermSheet, type, status) => {
    if (type === "delete") {
      setId(dossierTermSheet);
      setOpenDel(true);
    } else if (type === "edit") {
      setId(dossierTermSheet);
      setOpen(true);
      setType("edit");
      setStatus(status);
    } else if (type === "upload") {
      setOpenUpload(true);
      setType("upload");
    }
  };

  //Function to make close the dailog box close
  const handleClose = () => {
    setOpen(false);
    setOpenDel(false);
    setType("");
    setFile("");
    setStatus(false);
    setOpenUpload(false);
  };

  //
  const handleSubmit = () => {
    if (type === "edit") {
      const data = {
        id: id,
        status: !status,
      };
      axios
        .post(process.env.REACT_APP_BACKEND + "update-dossierTermSheet", data, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem("token")}`,
          },
        })
        .then((resp) => {
          toast.success(resp && resp.data && resp.data.msg);
          getAllDossierTermsheet(0, "");
          handleClose();
        })
        .catch((err) => {
          toast.error(
            err && err.response && err.response.data && err.response.data.msg
          );
        });
    } else if (type === "upload") {
      let formData = new FormData();
      formData.append("file", file);

      axios
        .post(
          process.env.REACT_APP_BACKEND + "create-dossierTermSheet",
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage?.getItem("token")}`,
            },
          }
        )
        .then((resp) => {
          toast.success(resp && resp.data && resp.data.msg);
          getAllDossierTermsheet(0, "");
          handleClose();
        })
        .catch((err) => {
          toast.error(
            err && err.response && err.response.data && err.response.data.msg
          );
        });
    } else {
      const data = {
        id: id,
      };

      axios
        .post(process.env.REACT_APP_BACKEND + "delete-dossertermsheet", data, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem("token")}`,
          },
        })
        .then((resp) => {
          toast.success(resp && resp.data && resp.data.msg);
          getAllDossierTermsheet(0, "");
          handleClose();
        })
        .catch((err) => {
          toast.error(
            err && err.response && err.response.data && err.response.data.msg
          );
        });
    }
  };
  const handleFileChange = (event) => {
    const files = event.target.files[0];
    setFile(files);
  };
  return (
    <div className="p-4">
      <div
        className="mb-5"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2 className="primary_title text-start about_heading m-2 mb-3">
          Dossier Termsheet
        </h2>
        {/* <Button
          variant="contained"
          className="btn ms-4"
          onClick={() => handleOpen("", "upload")}
        >
          Upload CSV
        </Button> */}
      </div>

      <MUIDataTable
        // title={"DosserTermSheet Management"}
        data={dossierTermSheet}
        columns={columns}
        options={options}
      />

      {/* Dialog box foe create and edit opetator */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
      >
        <div className="d-flex justify-content-between align-items-center p-3">
          <h3 className="mb-0">Edit Dosser TermSheet Status</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14 fw-500">
            {status
              ? "Are sure want to Inactive Dosser TermSheet.?"
              : "Are sure want to Active Dosser TermSheet.?"}
          </p>
          <div className="text-center mt-4">
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              className="small-button ms-4"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* Dialog box to delete the operator */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel}
      >
        <div className="d-flex justify-content-between align-items-center p-3">
          <h3 className="mb-0">Delete Dosser TermSheet</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14 fw-500">
            Are you sure you want to delete the Dosser TermSheet ?
          </p>
        </DialogContent>

        <div className="text-center mt-4 mb-4" dividers>
          <Button
            variant="outlined"
            className="borderbtn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="btn ms-4"
            onClick={handleSubmit}
          >
            Delete
          </Button>
        </div>
      </Dialog>

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={openUpload}
      >
        <div className="d-flex justify-content-between align-items-center p-3">
          <h3 className="mb-0">Upload Dosser TermSheet</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <div className="m-auto text-center">
            <input
              type="file"
              id="cda"
              onChange={handleFileChange}
              multiple // Allows multiple file selection if needed
            />
          </div>
        </DialogContent>

        <div className="text-center mt-4 mb-4" dividers>
          <Button
            variant="outlined"
            className="borderbtn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="btn ms-4"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default DosserTermSheet;
